// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.atj {
  background: var(--c-cream);
  padding-block: var(--section-y);
  border-top: 1px solid var(--line);
  overflow-x: hidden;
}

.atj__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(1rem, 3vw, 2.5rem);
  margin-bottom: clamp(2.5rem, 5vw, 4rem);
}
.atj__rule {
  flex: 1 1;
  max-width: 8rem;
  height: 1px;
  background: var(--line);
  display: block;
}
.atj__heading {
  color: var(--c-ink) !important;
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}

/* Horizontal scrollable step row */
.atj__steps {
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: var(--sp-2);
}
.atj__steps::-webkit-scrollbar {
  display: none;
}

.atj__group {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}
.atj__group:last-child {
  flex: 0 0 auto;
}

.atj__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-3);
  flex-shrink: 0;
  min-width: clamp(90px, 10vw, 130px);
}

.atj__circle {
  width: clamp(50px, 6.5vw, 74px);
  height: clamp(50px, 6.5vw, 74px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(1.1rem, 1.8vw, 1.6rem);
  color: rgba(255, 255, 255, 0.92);
  flex-shrink: 0;
}

.atj__num {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 500;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.atj__label {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  color: var(--c-ink);
  margin: 0;
  line-height: var(--lh-snug);
}

.atj__desc {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  line-height: var(--lh-snug);
  margin: 0;
  max-width: 9rem;
}

/* Dashed connector */
.atj__dash {
  flex: 1 1;
  height: 1.5px;
  border-top: 1.5px dashed rgba(27, 27, 27, 0.18);
  margin-bottom: clamp(5rem, 7vw, 6rem);
  min-width: 0.75rem;
}

@media (max-width: 1200px) {
  .atj__steps {
    flex-direction: column;
    align-items: flex-start;
    overflow: visible;
  }
  .atj__group {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .atj__step {
    flex-direction: row;
    text-align: left;
    align-items: flex-start;
    min-width: 0;
    width: 100%;
  }
  .atj__dash {
    width: 2px;
    height: 1.5rem;
    border-top: none;
    border-left: 1.5px dashed rgba(27, 27, 27, 0.2);
    margin: var(--sp-2) 0 var(--sp-2) calc(clamp(50px, 6.5vw, 74px) / 2);
  }
}

/* ── Mobile font size fixes ── */
@media (max-width: 1200px) {
  .atj__circle {
    width: 58px;
    height: 58px;
    font-size: 1.3rem;
  }
  .atj__num {
    font-size: var(--fs-sm);
  }
  .atj__label {
    font-size: var(--fs-sm);
    letter-spacing: 0.14em;
  }
  .atj__desc {
    font-size: var(--fs-sm);
    max-width: none;
  }
}

/* ── Mobile design match ── */
@media (max-width: 1200px) {
  .atj {
    padding-block: var(--sp-8);
  }
  .atj__heading {
    font-size: var(--fs-body);
  }
  .atj__circle {
    width: 64px;
    height: 64px;
    font-size: 1.4rem;
  }
  .atj__num {
    font-size: var(--fs-sm);
  }
  .atj__label {
    font-size: var(--fs-sm);
    font-weight: 700;
    letter-spacing: 0.12em;
  }
  .atj__desc {
    font-size: var(--fs-sm);
    max-width: none;
  }
  /* Each step: icon left, text right (horizontal row on mobile) */
  .atj__step {
    flex-direction: row;
    text-align: left;
    align-items: flex-start;
    width: 100%;
    gap: var(--sp-4);
    min-width: 0;
  }
  .atj__step-text {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: var(--sp-1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyTheJourney.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,+CAA+C;IAC/C,oEAAoE;EACtE;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA,gEAAgE;EAChE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;AACF","sourcesContent":[".atj {\n  background: var(--c-cream);\n  padding-block: var(--section-y);\n  border-top: 1px solid var(--line);\n  overflow-x: hidden;\n}\n\n.atj__header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(1rem, 3vw, 2.5rem);\n  margin-bottom: clamp(2.5rem, 5vw, 4rem);\n}\n.atj__rule {\n  flex: 1;\n  max-width: 8rem;\n  height: 1px;\n  background: var(--line);\n  display: block;\n}\n.atj__heading {\n  color: var(--c-ink) !important;\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n/* Horizontal scrollable step row */\n.atj__steps {\n  display: flex;\n  align-items: flex-start;\n  overflow-x: auto;\n  scrollbar-width: none;\n  padding-bottom: var(--sp-2);\n}\n.atj__steps::-webkit-scrollbar {\n  display: none;\n}\n\n.atj__group {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n.atj__group:last-child {\n  flex: 0 0 auto;\n}\n\n.atj__step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--sp-3);\n  flex-shrink: 0;\n  min-width: clamp(90px, 10vw, 130px);\n}\n\n.atj__circle {\n  width: clamp(50px, 6.5vw, 74px);\n  height: clamp(50px, 6.5vw, 74px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: clamp(1.1rem, 1.8vw, 1.6rem);\n  color: rgba(255, 255, 255, 0.92);\n  flex-shrink: 0;\n}\n\n.atj__num {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 500;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n.atj__label {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  color: var(--c-ink);\n  margin: 0;\n  line-height: var(--lh-snug);\n}\n\n.atj__desc {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  line-height: var(--lh-snug);\n  margin: 0;\n  max-width: 9rem;\n}\n\n/* Dashed connector */\n.atj__dash {\n  flex: 1;\n  height: 1.5px;\n  border-top: 1.5px dashed rgba(27, 27, 27, 0.18);\n  margin-bottom: clamp(5rem, 7vw, 6rem);\n  min-width: 0.75rem;\n}\n\n@media (max-width: 1200px) {\n  .atj__steps {\n    flex-direction: column;\n    align-items: flex-start;\n    overflow: visible;\n  }\n  .atj__group {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n  .atj__step {\n    flex-direction: row;\n    text-align: left;\n    align-items: flex-start;\n    min-width: 0;\n    width: 100%;\n  }\n  .atj__dash {\n    width: 2px;\n    height: 1.5rem;\n    border-top: none;\n    border-left: 1.5px dashed rgba(27, 27, 27, 0.2);\n    margin: var(--sp-2) 0 var(--sp-2) calc(clamp(50px, 6.5vw, 74px) / 2);\n  }\n}\n\n/* ── Mobile font size fixes ── */\n@media (max-width: 1200px) {\n  .atj__circle {\n    width: 58px;\n    height: 58px;\n    font-size: 1.3rem;\n  }\n  .atj__num {\n    font-size: var(--fs-sm);\n  }\n  .atj__label {\n    font-size: var(--fs-sm);\n    letter-spacing: 0.14em;\n  }\n  .atj__desc {\n    font-size: var(--fs-sm);\n    max-width: none;\n  }\n}\n\n/* ── Mobile design match ── */\n@media (max-width: 1200px) {\n  .atj {\n    padding-block: var(--sp-8);\n  }\n  .atj__heading {\n    font-size: var(--fs-body);\n  }\n  .atj__circle {\n    width: 64px;\n    height: 64px;\n    font-size: 1.4rem;\n  }\n  .atj__num {\n    font-size: var(--fs-sm);\n  }\n  .atj__label {\n    font-size: var(--fs-sm);\n    font-weight: 700;\n    letter-spacing: 0.12em;\n  }\n  .atj__desc {\n    font-size: var(--fs-sm);\n    max-width: none;\n  }\n  /* Each step: icon left, text right (horizontal row on mobile) */\n  .atj__step {\n    flex-direction: row;\n    text-align: left;\n    align-items: flex-start;\n    width: 100%;\n    gap: var(--sp-4);\n    min-width: 0;\n  }\n  .atj__step-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: var(--sp-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
